import { render } from "./App.vue?vue&type=template&id=72e771e1"
const script = {}

import "./App.vue?vue&type=style&index=0&id=72e771e1&lang=less"

import exportComponent from "/data/__qci/root-workspaces/__qci-pipeline-297355-1/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__